/**
 * defa.collections.generalAlarmInputs
 * A Collection of GeneralAlarmInput
 * @version 1.2.0
 */
import GeneralAlarmInput from './model-general-alarm-input';

const GeneralAlarmInputs = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : GeneralAlarmInput,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default GeneralAlarmInputs;